import RouterViewBody from '~/views/RouterViewBody.vue'
export default [
  {
    path: 'sales',
    name: 'sales',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    props: { type: 'sales' },
    redirect: { name: 'Sales' },
    meta: {
      access: { abilities: ['view_sales'] },
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.pages.buttons.prodazhi,
    },
    children: [
      {
        path: 'all',
        component: RouterViewBody,
        meta: {
          responsive: true,
        },

        children: [
          {
            path: '',
            name: 'Sales',
            component: () => import('~/views/sales/salesAll.vue'),
            meta: {
              search: true,
              responsive: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: 'project-create',
            name: 'SalesProjectCreate',
            component: () => import('~/views/sales/salesProjectCreate.vue'),
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.common.breadcrumbs.sozdanie,
              access: { abilities: ['edit_sales'] },
              responsive: true,
            },
          },
          {
            path: 'project-create/:id',
            name: 'SalesProjectCreateContinue',
            component: () => import('~/views/sales/salesProjectCreate.vue'),
            meta: {
              breadCrumbGetter: 'workClientProject/workClientProjectShow',
              breadCrumb: (project) => project.name,
              access: { abilities: ['edit_sales'] },
              responsive: true,
            },
          },
          {
            path: ':id',
            component: RouterViewBody,
            meta: {
              breadCrumbGetter: 'workClientProject/workClientProjectShow',
              breadCrumb: (project) => project.name,
            },
            children: [
              {
                path: '',
                name: 'SalesProjectShow',
                component: () => import('~/views/sales/salesProjectShow.vue'),
                meta: {
                  responsive: true,
                },
              },
              {
                path: 'edit',
                name: 'SalesProjectShowEdit',
                component: () => import('~/views/sales/salesProjectShow.vue'),
                meta: {
                  access: { abilities: ['edit_sales'] },
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.common.breadcrumbs['redaktirovanie'],
                  responsive: true,
                },
              },
              {
                path: 'project-proposed',
                name: 'SalesProjectProposed',
                component: () => import('~/views/sales/salesProjectProposed.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.price_offer_terms.title,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'archive',
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.sales.pages.arhiv,
        },
        children: [
          {
            path: '',
            name: 'SalesArchive',
            component: () => import('~/views/sales/salesAll.vue'),
            meta: {
              responsive: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: ':id',
            component: RouterViewBody,
            meta: {
              breadCrumbGetter: 'workClientProject/workClientProjectShow',
              breadCrumb: (project) => project.name,
            },
            pathToRegexpOptions: { strict: false },
            children: [
              {
                path: '',
                name: 'SalesArchiveShow',
                component: () => import('~/views/sales/salesProjectShow.vue'),
                meta: {
                  responsive: true,
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
